
import Call from './Call';

export const test = ( playlistUrl, markAsTest = true) => {
  const baseUrl = playlistUrl.split('/').slice(0,-1).join('/');
  return Call.get( playlistUrl, {}, { parseResponse: true }).then( response => {
    const chunklistPath = response.split('\n').reduce( (prev, next) => prev || (next[0] !== '#' && !/^\s+$/.exec(next) && next), null);
    if( !chunklistPath) return Promise.reject({ message: 'm3u8 without chunklist' });
    const chunklistUrl = `${baseUrl}/${chunklistPath}`;
    return Call.head( chunklistUrl);
  });
};
  